export const DELAY = 500;
